module.exports = __webpack_public_path__ + "img/co_4.73af09ad.png";